import { IconWrap, DeleteIcon, Flex } from '@libs/ui/ds'
import React from 'react'

export const ForbiddenDropZone = () => {
  return (
    <Flex className='size-full items-center justify-center rounded-sm bg-neutral-50 opacity-80'>
      <IconWrap icon={<DeleteIcon />} size='l' />
    </Flex>
  )
}
